import { render, staticRenderFns } from "./UserBindInfo.vue?vue&type=template&id=aa397000&"
import script from "./UserBindInfo.vue?vue&type=script&lang=js&"
export * from "./UserBindInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserBindInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports